import { ReactElement } from 'react';

import { Bonus } from '../../../../types/bonus';
import { Token, TokenType } from '../../lib/bonus/lexer';
import { Amount, Hashtag, Mention, Text } from './TokenComponents';

interface Props {
	token: Token;
	bonus: Bonus;
	highlight?: string;
}

const TokenMap: Partial<Record<TokenType, (text: string, bonus: Bonus, highlight?: string) => ReactElement>> = {
	[TokenType.AMOUNT]: (text: string) => Amount(text),
	[TokenType.HASHTAG]: (text: string) => Hashtag(text),
	[TokenType.MENTION]: (text: string, bonus) => Mention(text, bonus),
	[TokenType.TEXT]: (text: string, b, highlight) => Text(text, highlight),
	[TokenType.USER_TAG]: (text: string, b, highlight) => Text(text, highlight),
};

const BonusTextSegment = ({ token: { kind, text }, bonus, highlight }: Props) => {
	const tokenMap = TokenMap[kind];
	return tokenMap ? tokenMap(text, bonus, highlight) : <></>;
};

export default BonusTextSegment;
